export const PlotDoctorStatus = {
  NOT_PROCESSED: 'NOT_PROCESSED',
  PROCESSING: 'PROCESSING',
  RETRYING: 'RETRYING',
  FINISHED_WITH_SUCCESS: 'FINISHED_WITH_SUCCESS',
  FINISHED_WITH_ERROR: 'FINISHED_WITH_ERROR',
  FINISHED_NO_CROP: 'FINISHED_NO_CROP',

  finishedWithError: (status: string): boolean => {
    return status === PlotDoctorStatus.FINISHED_WITH_ERROR;
  },

  finishedWithSuccess: (status: string): boolean => {
    return status === PlotDoctorStatus.FINISHED_WITH_SUCCESS 
      || status === PlotDoctorStatus.FINISHED_NO_CROP;
  },

  processing: (status: string): boolean => {
    return status === PlotDoctorStatus.NOT_PROCESSED 
    || status === PlotDoctorStatus.PROCESSING 
    || status === PlotDoctorStatus.RETRYING;
  }
};
